export default defineNuxtRouteMiddleware((to) => {
  const { user } = useTelaSession()
  if (to.path === '/login' && user.value) {
    const destination = to.query.redirect ? to.query.redirect as string : '/'
    return navigateTo(destination)
  }

  if (to.path === '/applications/login' && user.value) {
    const query = to.query as Record<string, string>
    const destination = query.redirect ? query.redirect : { path: '/applications/pick-org', query }
    return navigateTo(destination)
  }

  if (to.meta.auth === false) {
    return
  }

  if (!user.value) {
    const redirectUrl = encodeURIComponent(`${to.fullPath}`)
    return navigateTo(`/login?redirect=${redirectUrl}`)
  }
})
